module.exports = __webpack_public_path__ + "static/media/brain.1a8ba41f.png";